import { useTranslation } from "react-i18next";

export const DmcIntroImage = () => {
  const { t } = useTranslation();
  return (
    <svg width="328" height="205" viewBox="0 0 328 205" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="328" height="205" fill="#EBEEF0" />
      <rect x="20" y="66" width="276" height="139" fill="#D9D9D9" />
      <g opacity="0.2" clip-path="url(#clip0_14865_10505)">
        <circle cx="52.6593" cy="86.2577" r="13.0636" stroke="#646464" stroke-width="2" />
        <g filter="url(#filter0_d_14865_10505)">
          <circle
            cx="52.6593"
            cy="86.2577"
            r="8.39804"
            stroke="#646464"
            stroke-width="2"
            shape-rendering="crispEdges"
          />
        </g>
        <circle cx="50.793" cy="75.9934" r="1.86623" fill="#646464" />
        <circle cx="57.3247" cy="76.9265" r="1.86623" fill="#646464" />
        <circle cx="61.9903" cy="80.6591" r="1.86623" fill="#646464" />
        <circle cx="63.8565" cy="86.2577" r="1.86623" fill="#646464" />
        <circle cx="61.9903" cy="90.9232" r="1.86623" fill="#646464" />
        <circle cx="58.2578" cy="95.5889" r="1.86623" fill="#646464" />
        <circle cx="52.6592" cy="96.522" r="1.86623" fill="#646464" />
        <circle cx="46.1275" cy="94.6558" r="1.86623" fill="#646464" />
        <circle cx="42.395" cy="89.9901" r="1.86623" fill="#646464" />
        <circle cx="42.395" cy="83.4584" r="1.86623" fill="#646464" />
        <circle cx="45.1944" cy="78.7927" r="1.86623" fill="#646464" />
        <circle cx="108.646" cy="86.2578" r="13.0636" stroke="#646464" stroke-width="2" />
        <g filter="url(#filter1_d_14865_10505)">
          <circle
            cx="108.646"
            cy="86.2578"
            r="8.39804"
            stroke="#646464"
            stroke-width="2"
            shape-rendering="crispEdges"
          />
        </g>
        <circle cx="106.78" cy="75.9936" r="1.86623" fill="#646464" />
        <circle cx="113.312" cy="76.9267" r="1.86623" fill="#646464" />
        <circle cx="117.978" cy="80.6592" r="1.86623" fill="#646464" />
        <circle cx="119.844" cy="86.2578" r="1.86623" fill="#646464" />
        <circle cx="117.978" cy="90.9234" r="1.86623" fill="#646464" />
        <circle cx="114.245" cy="95.589" r="1.86623" fill="#646464" />
        <circle cx="108.646" cy="96.5221" r="1.86623" fill="#646464" />
        <circle cx="102.114" cy="94.6559" r="1.86623" fill="#646464" />
        <circle cx="98.3819" cy="89.9903" r="1.86623" fill="#646464" />
        <circle cx="98.3819" cy="83.4585" r="1.86623" fill="#646464" />
        <circle cx="101.181" cy="78.7929" r="1.86623" fill="#646464" />
        <circle cx="164.633" cy="86.2578" r="13.0636" stroke="#646464" stroke-width="2" />
        <g filter="url(#filter2_d_14865_10505)">
          <circle
            cx="164.633"
            cy="86.2578"
            r="8.39804"
            stroke="#646464"
            stroke-width="2"
            shape-rendering="crispEdges"
          />
        </g>
        <circle cx="162.767" cy="75.9936" r="1.86623" fill="#646464" />
        <circle cx="169.298" cy="76.9267" r="1.86623" fill="#646464" />
        <circle cx="173.964" cy="80.6592" r="1.86623" fill="#646464" />
        <circle cx="175.83" cy="86.2578" r="1.86623" fill="#646464" />
        <circle cx="173.964" cy="90.9234" r="1.86623" fill="#646464" />
        <circle cx="170.231" cy="95.589" r="1.86623" fill="#646464" />
        <circle cx="164.633" cy="96.5221" r="1.86623" fill="#646464" />
        <circle cx="158.101" cy="94.6559" r="1.86623" fill="#646464" />
        <circle cx="154.369" cy="89.9903" r="1.86623" fill="#646464" />
        <circle cx="154.369" cy="83.4585" r="1.86623" fill="#646464" />
        <circle cx="157.168" cy="78.7929" r="1.86623" fill="#646464" />
        <circle cx="220.62" cy="86.2578" r="13.0636" stroke="#646464" stroke-width="2" />
        <g filter="url(#filter3_d_14865_10505)">
          <circle cx="220.62" cy="86.2578" r="8.39804" stroke="#646464" stroke-width="2" shape-rendering="crispEdges" />
        </g>
        <circle cx="218.753" cy="75.9936" r="1.86623" fill="#646464" />
        <circle cx="225.285" cy="76.9267" r="1.86623" fill="#646464" />
        <circle cx="229.951" cy="80.6592" r="1.86623" fill="#646464" />
        <circle cx="231.817" cy="86.2578" r="1.86623" fill="#646464" />
        <circle cx="229.951" cy="90.9234" r="1.86623" fill="#646464" />
        <circle cx="226.218" cy="95.589" r="1.86623" fill="#646464" />
        <circle cx="220.62" cy="96.5221" r="1.86623" fill="#646464" />
        <circle cx="214.088" cy="94.6559" r="1.86623" fill="#646464" />
        <circle cx="210.355" cy="89.9903" r="1.86623" fill="#646464" />
        <circle cx="210.355" cy="83.4585" r="1.86623" fill="#646464" />
        <circle cx="213.155" cy="78.7929" r="1.86623" fill="#646464" />
        <circle cx="276.607" cy="86.2578" r="13.0636" stroke="#646464" stroke-width="2" />
        <g filter="url(#filter4_d_14865_10505)">
          <circle
            cx="276.607"
            cy="86.2578"
            r="8.39804"
            stroke="#646464"
            stroke-width="2"
            shape-rendering="crispEdges"
          />
        </g>
        <circle cx="274.74" cy="75.9936" r="1.86623" fill="#646464" />
        <circle cx="281.272" cy="76.9267" r="1.86623" fill="#646464" />
        <circle cx="285.938" cy="80.6592" r="1.86623" fill="#646464" />
        <circle cx="287.804" cy="86.2578" r="1.86623" fill="#646464" />
        <circle cx="285.938" cy="90.9234" r="1.86623" fill="#646464" />
        <circle cx="282.205" cy="95.589" r="1.86623" fill="#646464" />
        <circle cx="276.606" cy="96.5221" r="1.86623" fill="#646464" />
        <circle cx="270.075" cy="94.6559" r="1.86623" fill="#646464" />
        <circle cx="266.342" cy="89.9903" r="1.86623" fill="#646464" />
        <circle cx="266.342" cy="83.4585" r="1.86623" fill="#646464" />
        <circle cx="269.142" cy="78.7929" r="1.86623" fill="#646464" />
        <circle cx="52.6593" cy="132.914" r="13.0636" stroke="#646464" stroke-width="2" />
        <g filter="url(#filter5_d_14865_10505)">
          <circle
            cx="52.6593"
            cy="132.914"
            r="8.39804"
            stroke="#646464"
            stroke-width="2"
            shape-rendering="crispEdges"
          />
        </g>
        <circle cx="50.793" cy="122.649" r="1.86623" fill="#646464" />
        <circle cx="57.3247" cy="123.583" r="1.86623" fill="#646464" />
        <circle cx="61.9903" cy="127.315" r="1.86623" fill="#646464" />
        <circle cx="63.8565" cy="132.914" r="1.86623" fill="#646464" />
        <circle cx="61.9903" cy="137.579" r="1.86623" fill="#646464" />
        <circle cx="58.2578" cy="142.245" r="1.86623" fill="#646464" />
        <circle cx="52.6592" cy="143.178" r="1.86623" fill="#646464" />
        <circle cx="46.1275" cy="141.312" r="1.86623" fill="#646464" />
        <circle cx="42.395" cy="136.646" r="1.86623" fill="#646464" />
        <circle cx="42.395" cy="130.114" r="1.86623" fill="#646464" />
        <circle cx="45.1944" cy="125.449" r="1.86623" fill="#646464" />
        <circle cx="108.646" cy="132.914" r="13.0636" stroke="#646464" stroke-width="2" />
        <g filter="url(#filter6_d_14865_10505)">
          <circle
            cx="108.646"
            cy="132.914"
            r="8.39804"
            stroke="#646464"
            stroke-width="2"
            shape-rendering="crispEdges"
          />
        </g>
        <circle cx="106.78" cy="122.649" r="1.86623" fill="#646464" />
        <circle cx="113.312" cy="123.583" r="1.86623" fill="#646464" />
        <circle cx="117.978" cy="127.315" r="1.86623" fill="#646464" />
        <circle cx="119.844" cy="132.914" r="1.86623" fill="#646464" />
        <circle cx="117.978" cy="137.579" r="1.86623" fill="#646464" />
        <circle cx="114.245" cy="142.245" r="1.86623" fill="#646464" />
        <circle cx="108.646" cy="143.178" r="1.86623" fill="#646464" />
        <circle cx="102.114" cy="141.312" r="1.86623" fill="#646464" />
        <circle cx="98.3819" cy="136.646" r="1.86623" fill="#646464" />
        <circle cx="98.3819" cy="130.114" r="1.86623" fill="#646464" />
        <circle cx="101.181" cy="125.449" r="1.86623" fill="#646464" />
        <circle cx="164.633" cy="132.914" r="13.0636" stroke="#646464" stroke-width="2" />
        <g filter="url(#filter7_d_14865_10505)">
          <circle
            cx="164.633"
            cy="132.914"
            r="8.39804"
            stroke="#646464"
            stroke-width="2"
            shape-rendering="crispEdges"
          />
        </g>
        <circle cx="162.767" cy="122.649" r="1.86623" fill="#646464" />
        <circle cx="169.298" cy="123.583" r="1.86623" fill="#646464" />
        <circle cx="173.964" cy="127.315" r="1.86623" fill="#646464" />
        <circle cx="175.83" cy="132.914" r="1.86623" fill="#646464" />
        <circle cx="173.964" cy="137.579" r="1.86623" fill="#646464" />
        <circle cx="170.231" cy="142.245" r="1.86623" fill="#646464" />
        <circle cx="164.633" cy="143.178" r="1.86623" fill="#646464" />
        <circle cx="158.101" cy="141.312" r="1.86623" fill="#646464" />
        <circle cx="154.369" cy="136.646" r="1.86623" fill="#646464" />
        <circle cx="154.369" cy="130.114" r="1.86623" fill="#646464" />
        <circle cx="157.168" cy="125.449" r="1.86623" fill="#646464" />
        <circle cx="220.62" cy="132.914" r="13.0636" stroke="#646464" stroke-width="2" />
        <g filter="url(#filter8_d_14865_10505)">
          <circle cx="220.62" cy="132.914" r="8.39804" stroke="#646464" stroke-width="2" shape-rendering="crispEdges" />
        </g>
        <circle cx="218.753" cy="122.649" r="1.86623" fill="#646464" />
        <circle cx="225.285" cy="123.583" r="1.86623" fill="#646464" />
        <circle cx="229.951" cy="127.315" r="1.86623" fill="#646464" />
        <circle cx="231.817" cy="132.914" r="1.86623" fill="#646464" />
        <circle cx="229.951" cy="137.579" r="1.86623" fill="#646464" />
        <circle cx="226.218" cy="142.245" r="1.86623" fill="#646464" />
        <circle cx="220.62" cy="143.178" r="1.86623" fill="#646464" />
        <circle cx="214.088" cy="141.312" r="1.86623" fill="#646464" />
        <circle cx="210.355" cy="136.646" r="1.86623" fill="#646464" />
        <circle cx="210.355" cy="130.114" r="1.86623" fill="#646464" />
        <circle cx="213.155" cy="125.449" r="1.86623" fill="#646464" />
        <circle cx="276.607" cy="132.914" r="13.0636" stroke="#646464" stroke-width="2" />
        <g filter="url(#filter9_d_14865_10505)">
          <circle
            cx="276.607"
            cy="132.914"
            r="8.39804"
            stroke="#646464"
            stroke-width="2"
            shape-rendering="crispEdges"
          />
        </g>
        <circle cx="274.74" cy="122.649" r="1.86623" fill="#646464" />
        <circle cx="281.272" cy="123.583" r="1.86623" fill="#646464" />
        <circle cx="285.938" cy="127.315" r="1.86623" fill="#646464" />
        <circle cx="287.804" cy="132.914" r="1.86623" fill="#646464" />
        <circle cx="285.938" cy="137.579" r="1.86623" fill="#646464" />
        <circle cx="282.205" cy="142.245" r="1.86623" fill="#646464" />
        <circle cx="276.606" cy="143.178" r="1.86623" fill="#646464" />
        <circle cx="270.075" cy="141.312" r="1.86623" fill="#646464" />
        <circle cx="266.342" cy="136.646" r="1.86623" fill="#646464" />
        <circle cx="266.342" cy="130.114" r="1.86623" fill="#646464" />
        <circle cx="269.142" cy="125.449" r="1.86623" fill="#646464" />
        <circle cx="52.6593" cy="179.569" r="13.0636" stroke="#646464" stroke-width="2" />
        <g filter="url(#filter10_d_14865_10505)">
          <circle
            cx="52.6593"
            cy="179.569"
            r="8.39804"
            stroke="#646464"
            stroke-width="2"
            shape-rendering="crispEdges"
          />
        </g>
        <circle cx="50.793" cy="169.305" r="1.86623" fill="#646464" />
        <circle cx="57.3247" cy="170.238" r="1.86623" fill="#646464" />
        <circle cx="61.9903" cy="173.971" r="1.86623" fill="#646464" />
        <circle cx="63.8565" cy="179.569" r="1.86623" fill="#646464" />
        <circle cx="61.9903" cy="184.235" r="1.86623" fill="#646464" />
        <circle cx="58.2578" cy="188.9" r="1.86623" fill="#646464" />
        <circle cx="52.6592" cy="189.834" r="1.86623" fill="#646464" />
        <circle cx="46.1275" cy="187.967" r="1.86623" fill="#646464" />
        <circle cx="42.395" cy="183.302" r="1.86623" fill="#646464" />
        <circle cx="42.395" cy="176.77" r="1.86623" fill="#646464" />
        <circle cx="45.1944" cy="172.105" r="1.86623" fill="#646464" />
        <circle cx="108.646" cy="179.569" r="13.0636" stroke="#646464" stroke-width="2" />
        <g filter="url(#filter11_d_14865_10505)">
          <circle
            cx="108.646"
            cy="179.569"
            r="8.39804"
            stroke="#646464"
            stroke-width="2"
            shape-rendering="crispEdges"
          />
        </g>
        <circle cx="106.78" cy="169.305" r="1.86623" fill="#646464" />
        <circle cx="113.312" cy="170.238" r="1.86623" fill="#646464" />
        <circle cx="117.978" cy="173.971" r="1.86623" fill="#646464" />
        <circle cx="119.844" cy="179.569" r="1.86623" fill="#646464" />
        <circle cx="117.978" cy="184.235" r="1.86623" fill="#646464" />
        <circle cx="114.245" cy="188.9" r="1.86623" fill="#646464" />
        <circle cx="108.646" cy="189.834" r="1.86623" fill="#646464" />
        <circle cx="102.114" cy="187.967" r="1.86623" fill="#646464" />
        <circle cx="98.3819" cy="183.302" r="1.86623" fill="#646464" />
        <circle cx="98.3819" cy="176.77" r="1.86623" fill="#646464" />
        <circle cx="101.181" cy="172.105" r="1.86623" fill="#646464" />
        <circle cx="164.633" cy="179.569" r="13.0636" stroke="#646464" stroke-width="2" />
        <g filter="url(#filter12_d_14865_10505)">
          <circle
            cx="164.633"
            cy="179.569"
            r="8.39804"
            stroke="#646464"
            stroke-width="2"
            shape-rendering="crispEdges"
          />
        </g>
        <circle cx="162.767" cy="169.305" r="1.86623" fill="#646464" />
        <circle cx="169.298" cy="170.238" r="1.86623" fill="#646464" />
        <circle cx="173.964" cy="173.971" r="1.86623" fill="#646464" />
        <circle cx="175.83" cy="179.569" r="1.86623" fill="#646464" />
        <circle cx="173.964" cy="184.235" r="1.86623" fill="#646464" />
        <circle cx="170.231" cy="188.9" r="1.86623" fill="#646464" />
        <circle cx="164.633" cy="189.834" r="1.86623" fill="#646464" />
        <circle cx="158.101" cy="187.967" r="1.86623" fill="#646464" />
        <circle cx="154.369" cy="183.302" r="1.86623" fill="#646464" />
        <circle cx="154.369" cy="176.77" r="1.86623" fill="#646464" />
        <circle cx="157.168" cy="172.105" r="1.86623" fill="#646464" />
        <circle cx="220.62" cy="179.569" r="13.0636" stroke="#646464" stroke-width="2" />
        <g filter="url(#filter13_d_14865_10505)">
          <circle cx="220.62" cy="179.569" r="8.39804" stroke="#646464" stroke-width="2" shape-rendering="crispEdges" />
        </g>
        <circle cx="218.753" cy="169.305" r="1.86623" fill="#646464" />
        <circle cx="225.285" cy="170.238" r="1.86623" fill="#646464" />
        <circle cx="229.951" cy="173.971" r="1.86623" fill="#646464" />
        <circle cx="231.817" cy="179.569" r="1.86623" fill="#646464" />
        <circle cx="229.951" cy="184.235" r="1.86623" fill="#646464" />
        <circle cx="226.218" cy="188.9" r="1.86623" fill="#646464" />
        <circle cx="220.62" cy="189.834" r="1.86623" fill="#646464" />
        <circle cx="214.088" cy="187.967" r="1.86623" fill="#646464" />
        <circle cx="210.355" cy="183.302" r="1.86623" fill="#646464" />
        <circle cx="210.355" cy="176.77" r="1.86623" fill="#646464" />
        <circle cx="213.155" cy="172.105" r="1.86623" fill="#646464" />
        <circle cx="276.607" cy="179.569" r="13.0636" stroke="#646464" stroke-width="2" />
        <g filter="url(#filter14_d_14865_10505)">
          <circle
            cx="276.607"
            cy="179.569"
            r="8.39804"
            stroke="#646464"
            stroke-width="2"
            shape-rendering="crispEdges"
          />
        </g>
        <circle cx="274.74" cy="169.305" r="1.86623" fill="#646464" />
        <circle cx="281.272" cy="170.238" r="1.86623" fill="#646464" />
        <circle cx="285.938" cy="173.971" r="1.86623" fill="#646464" />
        <circle cx="287.804" cy="179.569" r="1.86623" fill="#646464" />
        <circle cx="285.938" cy="184.235" r="1.86623" fill="#646464" />
        <circle cx="282.205" cy="188.9" r="1.86623" fill="#646464" />
        <circle cx="276.606" cy="189.834" r="1.86623" fill="#646464" />
        <circle cx="270.075" cy="187.967" r="1.86623" fill="#646464" />
        <circle cx="266.342" cy="183.302" r="1.86623" fill="#646464" />
        <circle cx="266.342" cy="176.77" r="1.86623" fill="#646464" />
        <circle cx="269.142" cy="172.105" r="1.86623" fill="#646464" />
      </g>
      <path d="M111 102C111 96.4772 115.477 92 121 92H276C281.523 92 286 96.4772 286 102V196H111V102Z" fill="white" />
      <rect x="234" y="99" width="44" height="41.758" rx="7" stroke="#00893D" stroke-width="2" />
      <rect x="240.36" y="104.34" width="1.36" height="30.6" fill="black" />
      <rect x="241.72" y="133.58" width="29.58" height="1.36" fill="black" />
      <rect x="243.08" y="104.34" width="1.36" height="1.36" fill="black" />
      <rect x="243.08" y="107.06" width="1.36" height="1.36" fill="black" />
      <rect x="243.08" y="111.14" width="2.72" height="1.36" fill="black" />
      <rect x="241.72" y="109.78" width="1.36" height="2.72" fill="black" />
      <rect x="246.14" y="107.06" width="1.36" height="1.36" fill="black" />
      <rect x="246.14" y="104.34" width="1.36" height="1.36" fill="black" />
      <rect x="248.86" y="104.34" width="1.36" height="1.36" fill="black" />
      <rect x="254.3" y="104.34" width="1.36" height="1.36" fill="black" />
      <rect x="252.94" y="108.42" width="1.36" height="1.36" fill="black" />
      <rect x="257.02" y="104.34" width="1.36" height="1.36" fill="black" />
      <rect x="262.8" y="104.34" width="1.36" height="1.36" fill="black" />
      <rect x="260.08" y="109.78" width="1.36" height="1.36" fill="black" />
      <rect x="264.16" y="121" width="1.36" height="1.36" fill="black" />
      <rect x="265.18" y="126.44" width="1.36" height="1.36" fill="black" />
      <rect x="257.36" y="132.22" width="1.36" height="1.36" fill="black" />
      <rect x="265.52" y="132.22" width="1.36" height="1.36" fill="black" />
      <rect x="268.24" y="126.44" width="1.36" height="1.36" fill="black" />
      <rect x="262.46" y="127.8" width="1.36" height="4.08" fill="black" />
      <rect x="269.6" y="122.36" width="1.36" height="1.36" fill="black" />
      <rect x="261.44" y="121" width="1.36" height="1.36" fill="black" />
      <rect x="255.66" y="122.36" width="1.36" height="1.36" fill="black" />
      <rect x="255.66" y="122.36" width="1.36" height="1.36" fill="black" />
      <rect x="245.8" y="127.8" width="1.36" height="1.36" fill="black" />
      <rect x="250.22" y="132.22" width="1.36" height="1.36" fill="black" />
      <rect x="251.58" y="129.16" width="1.36" height="1.36" fill="black" />
      <rect x="252.94" y="130.86" width="1.36" height="1.36" fill="black" />
      <rect x="252.94" y="132.22" width="2.72" height="1.36" fill="black" />
      <rect x="255.66" y="130.52" width="1.36" height="1.36" fill="black" />
      <rect x="244.44" y="129.16" width="1.36" height="1.36" fill="black" />
      <rect x="257.02" y="123.72" width="12.58" height="1.36" fill="black" />
      <rect x="254.3" y="123.72" width="1.36" height="2.72" fill="black" />
      <rect x="251.58" y="123.72" width="1.36" height="2.72" fill="black" />
      <rect x="248.86" y="129.5" width="1.36" height="2.72" fill="black" />
      <rect x="250.22" y="125.08" width="1.36" height="4.08" fill="black" />
      <rect x="258.72" y="130.86" width="1.36" height="2.72" fill="black" />
      <rect x="258.72" y="108.42" width="1.36" height="1.36" fill="black" />
      <rect x="255.66" y="113.86" width="1.36" height="1.36" fill="black" />
      <rect x="262.8" y="109.78" width="1.36" height="1.36" fill="black" />
      <rect x="264.16" y="112.5" width="1.36" height="1.36" fill="black" />
      <rect x="262.8" y="116.58" width="1.36" height="1.36" fill="black" />
      <rect x="261.44" y="107.06" width="2.72" height="1.36" fill="black" />
      <rect x="264.16" y="108.42" width="2.72" height="1.36" fill="black" />
      <rect x="254.3" y="116.92" width="2.72" height="2.72" fill="black" />
      <rect x="247.5" y="111.14" width="2.72" height="1.36" fill="black" />
      <rect x="241.72" y="114.2" width="2.72" height="2.72" fill="black" />
      <rect x="247.5" y="113.86" width="2.72" height="1.36" fill="black" />
      <rect x="264.16" y="115.22" width="2.72" height="1.36" fill="black" />
      <rect x="254.3" y="129.16" width="2.72" height="1.36" fill="black" />
      <rect x="268.24" y="116.92" width="2.72" height="1.36" fill="black" />
      <rect x="268.24" y="119.64" width="2.72" height="1.36" fill="black" />
      <rect x="268.24" y="125.08" width="2.72" height="1.36" fill="black" />
      <rect x="265.18" y="127.8" width="5.78" height="1.36" fill="black" />
      <rect x="266.88" y="130.86" width="4.42" height="1.36" fill="black" />
      <rect x="262.46" y="125.08" width="2.72" height="2.72" fill="black" />
      <rect x="266.88" y="121" width="2.72" height="2.72" fill="black" />
      <rect x="264.16" y="118.28" width="2.72" height="1.36" fill="black" />
      <rect x="269.6" y="105.7" width="1.36" height="1.36" fill="black" />
      <rect x="269.6" y="108.42" width="1.36" height="1.36" fill="black" />
      <rect x="269.6" y="111.14" width="1.36" height="1.36" fill="black" />
      <rect x="269.6" y="113.86" width="1.36" height="1.36" fill="black" />
      <rect x="255.66" y="105.7" width="1.36" height="2.72" fill="black" />
      <rect x="251.58" y="118.28" width="1.36" height="2.72" fill="black" />
      <rect x="257.36" y="109.78" width="1.36" height="2.72" fill="black" />
      <rect x="258.72" y="112.5" width="1.36" height="2.72" fill="black" />
      <rect x="257.36" y="115.22" width="1.36" height="2.72" fill="black" />
      <rect x="262.8" y="112.5" width="1.36" height="2.72" fill="black" />
      <rect x="261.44" y="111.14" width="1.36" height="6.8" fill="black" />
      <rect x="252.94" y="111.14" width="1.36" height="2.72" fill="black" />
      <rect x="254.3" y="109.78" width="1.36" height="5.44" fill="black" />
      <rect x="246.14" y="115.22" width="1.36" height="5.44" fill="black" />
      <rect x="241.72" y="125.08" width="1.36" height="6.8" fill="black" />
      <rect x="243.08" y="127.8" width="1.36" height="4.08" fill="black" />
      <rect x="241.72" y="116.92" width="1.36" height="4.08" fill="black" />
      <rect x="252.94" y="115.22" width="1.36" height="6.8" fill="black" />
      <rect x="260.08" y="104.34" width="1.36" height="2.72" fill="black" />
      <rect x="265.52" y="104.34" width="1.36" height="2.72" fill="black" />
      <rect x="266.88" y="105.7" width="1.36" height="2.72" fill="black" />
      <rect x="268.24" y="104.34" width="1.36" height="10.88" fill="black" />
      <rect x="266.88" y="110.12" width="1.36" height="9.52" fill="black" />
      <rect x="251.58" y="104.34" width="1.36" height="6.8" fill="black" />
      <rect x="250.22" y="105.7" width="1.36" height="1.36" fill="black" />
      <rect x="250.22" y="109.78" width="1.36" height="1.36" fill="black" />
      <rect x="248.86" y="108.42" width="1.36" height="1.36" fill="black" />
      <rect x="251.58" y="113.86" width="1.36" height="1.36" fill="black" />
      <rect x="243.08" y="118.28" width="1.36" height="1.36" fill="black" />
      <rect x="254.3" y="119.64" width="1.36" height="1.36" fill="black" />
      <rect x="250.22" y="121" width="1.36" height="1.36" fill="black" />
      <rect x="245.8" y="125.08" width="1.36" height="1.36" fill="black" />
      <rect x="243.08" y="121" width="1.36" height="1.36" fill="black" />
      <rect x="257.02" y="121" width="1.36" height="1.36" fill="black" />
      <rect x="244.78" y="105.7" width="4.08" height="1.36" fill="black" />
      <rect x="257.02" y="119.64" width="4.08" height="1.36" fill="black" />
      <rect x="257.02" y="125.08" width="4.08" height="1.36" fill="black" />
      <rect x="244.44" y="109.78" width="4.08" height="1.36" fill="black" />
      <rect x="241.72" y="122.36" width="6.8" height="1.36" fill="black" />
      <rect x="248.86" y="126.44" width="8.16" height="1.36" fill="black" />
      <rect x="254.3" y="127.8" width="6.8" height="1.36" fill="black" />
      <rect x="241.72" y="123.72" width="4.08" height="1.36" fill="black" />
      <rect x="244.78" y="116.92" width="4.08" height="1.36" fill="black" />
      <rect x="243.08" y="126.44" width="2.72" height="1.36" fill="black" />
      <rect x="246.14" y="130.86" width="2.72" height="1.36" fill="black" />
      <rect x="244.78" y="132.22" width="4.08" height="1.36" fill="black" />
      <rect x="260.08" y="122.36" width="4.08" height="1.36" fill="black" />
      <rect x="244.44" y="112.5" width="6.8" height="1.36" fill="black" />
      <rect x="122" y="147" width="132.502" height="7.26003" fill="#D9D9D9" />
      <rect x="122" y="159.487" width="132.502" height="4.35602" fill="#D9D9D9" />
      <rect x="122" y="166.513" width="104.109" height="4.35602" fill="#D9D9D9" />
      <rect x="122.185" y="100.994" width="2.79935" height="17.375" fill="black" />
      <rect x="125.917" y="100.994" width="1.86623" height="17.375" fill="black" />
      <rect x="129.649" y="100.994" width="0.933116" height="17.375" fill="black" />
      <rect x="132.449" y="100.994" width="2.79935" height="17.375" fill="black" />
      <rect x="137.114" y="100.994" width="0.933116" height="17.375" fill="black" />
      <rect x="138.98" y="100.994" width="0.933116" height="17.375" fill="black" />
      <rect x="140.847" y="100.994" width="0.933116" height="17.375" fill="black" />
      <rect x="142.713" y="100.994" width="1.86623" height="17.375" fill="black" />
      <rect x="145.513" y="100.994" width="2.79935" height="17.375" fill="black" />
      <rect x="149.245" y="100.994" width="1.86623" height="17.375" fill="black" />
      <rect x="152.044" y="100.994" width="1.86623" height="17.375" fill="black" />
      <rect x="154.844" y="100.994" width="0.933116" height="17.375" fill="black" />
      <rect x="157.643" y="100.994" width="0.933116" height="17.375" fill="black" />
      <rect x="160.442" y="100.994" width="0.933116" height="17.375" fill="black" />
      <rect x="163.242" y="100.994" width="0.933116" height="17.375" fill="black" />
      <rect x="172.573" y="100.994" width="0.933116" height="17.375" fill="black" />
      <rect x="174.439" y="100.994" width="0.933116" height="17.375" fill="black" />
      <rect x="176.305" y="100.994" width="1.86623" height="17.375" fill="black" />
      <rect x="179.104" y="100.994" width="1.86623" height="17.375" fill="black" />
      <rect x="181.904" y="100.994" width="1.86623" height="17.375" fill="black" />
      <rect x="184.703" y="100.994" width="0.933116" height="17.375" fill="black" />
      <rect x="186.569" y="100.994" width="0.933116" height="17.375" fill="black" />
      <rect x="166.041" y="100.994" width="1.86623" height="17.375" fill="black" />
      <rect x="168.84" y="100.994" width="2.79935" height="17.375" fill="black" />
      <text fill="black" style={{ whiteSpace: "pre" }} font-family="Arial" font-size="9" letter-spacing="0em">
        <tspan x="121" y="128.74">
          6312-ZR
        </tspan>
      </text>
      <path d="M37.363 61H307.5L296 66L20 66.2437L37.363 61Z" fill="#F9F6F6" />
      <path d="M296 66L307.5 61V205H296V66Z" fill="#C1C0C0" />
      <path d="M259 89L267.66 74L250.34 74L259 89ZM257.5 35L257.5 75.5L260.5 75.5L260.5 35L257.5 35Z" fill="#00893D" />
      <text
        fill="#646464"
        style={{ whiteSpace: "pre" }}
        font-family="Arial"
        font-size="14"
        font-weight="bold"
        letter-spacing="0em"
      >
        <tspan x="290" y="25.5068" text-anchor={"end"}>
          {t("page.scandmc.onpackaginglabel")}
        </tspan>
      </text>
      <defs>
        <filter
          id="filter0_d_14865_10505"
          x="39.2612"
          y="76.8596"
          width="26.7959"
          height="26.7961"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14865_10505" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14865_10505" result="shape" />
        </filter>
        <filter
          id="filter1_d_14865_10505"
          x="95.248"
          y="76.8597"
          width="26.7959"
          height="26.7961"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14865_10505" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14865_10505" result="shape" />
        </filter>
        <filter
          id="filter2_d_14865_10505"
          x="151.235"
          y="76.8597"
          width="26.7959"
          height="26.7961"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14865_10505" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14865_10505" result="shape" />
        </filter>
        <filter
          id="filter3_d_14865_10505"
          x="207.222"
          y="76.8597"
          width="26.7959"
          height="26.7961"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14865_10505" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14865_10505" result="shape" />
        </filter>
        <filter
          id="filter4_d_14865_10505"
          x="263.208"
          y="76.8597"
          width="26.7959"
          height="26.7961"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14865_10505" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14865_10505" result="shape" />
        </filter>
        <filter
          id="filter5_d_14865_10505"
          x="39.2612"
          y="123.516"
          width="26.7959"
          height="26.7961"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14865_10505" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14865_10505" result="shape" />
        </filter>
        <filter
          id="filter6_d_14865_10505"
          x="95.248"
          y="123.516"
          width="26.7959"
          height="26.7961"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14865_10505" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14865_10505" result="shape" />
        </filter>
        <filter
          id="filter7_d_14865_10505"
          x="151.235"
          y="123.516"
          width="26.7959"
          height="26.7961"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14865_10505" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14865_10505" result="shape" />
        </filter>
        <filter
          id="filter8_d_14865_10505"
          x="207.222"
          y="123.516"
          width="26.7959"
          height="26.7961"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14865_10505" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14865_10505" result="shape" />
        </filter>
        <filter
          id="filter9_d_14865_10505"
          x="263.208"
          y="123.516"
          width="26.7959"
          height="26.7961"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14865_10505" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14865_10505" result="shape" />
        </filter>
        <filter
          id="filter10_d_14865_10505"
          x="39.2612"
          y="170.171"
          width="26.7959"
          height="26.7961"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14865_10505" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14865_10505" result="shape" />
        </filter>
        <filter
          id="filter11_d_14865_10505"
          x="95.248"
          y="170.171"
          width="26.7959"
          height="26.7961"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14865_10505" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14865_10505" result="shape" />
        </filter>
        <filter
          id="filter12_d_14865_10505"
          x="151.235"
          y="170.171"
          width="26.7959"
          height="26.7961"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14865_10505" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14865_10505" result="shape" />
        </filter>
        <filter
          id="filter13_d_14865_10505"
          x="207.222"
          y="170.171"
          width="26.7959"
          height="26.7961"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14865_10505" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14865_10505" result="shape" />
        </filter>
        <filter
          id="filter14_d_14865_10505"
          x="263.208"
          y="170.171"
          width="26.7959"
          height="26.7961"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_14865_10505" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_14865_10505" result="shape" />
        </filter>
        <clipPath id="clip0_14865_10505">
          <rect width="250" height="133" fill="white" transform="translate(40 72)" />
        </clipPath>
      </defs>
    </svg>
  );
};
